import qs from "qs";

export const createCardsDuplicate = (
  originalCards,
  typeName,
  defaultTitles = {},
  defaultImage,
  fields = null,
) =>
  (originalCards || []).map((card, index) => {
    const attrs = card?.attributes || {};

    const cardObj = {
      name: `carte ${typeName} produit dupliqué ${index + 1}`,
      title: attrs.title || defaultTitles.title || null,
      subtitle: attrs.subtitle,
      description: attrs.description || defaultTitles.description || null,
      content: attrs.content || defaultTitles.content || null,
      image: attrs.image?.data?.id || defaultImage,
      image2: attrs.image2?.data?.id || defaultImage,
      imageMobile: attrs.imageMobile?.data?.id || defaultImage,
      imageMobile2: attrs.imageMobile2?.data?.id || defaultImage,
      buttonText: attrs.buttonText,
      buttonUrl: attrs.buttonUrl,
      showButton: attrs.showButton,
    };

    if (!fields) return cardObj;

    return Object.fromEntries(
      Object.entries(cardObj).filter(([key]) => fields.includes(key)),
    );
  });

const cardsPopulate = {
  populate: {
    cards: {
      populate: ["image", "image2"],
      sort: ["order:asc"],
    },
  },
};

export const PRODUCT_QUERY = qs.stringify({
  populate: {
    localizations: { populate: "*" },
    banner: { populate: "*" },
    image: { populate: { url: "*" } },
    image2: { populate: { url: "*" } },
    ficheTechnique: { populate: { url: "*" } },

    pointfort: cardsPopulate,
    realisation: cardsPopulate,
    pointreassurance: cardsPopulate,
    versionImages: cardsPopulate,
    jetList: cardsPopulate,
    colors: cardsPopulate,
    cuveColors: cardsPopulate,

    relatedProducts: { populate: "attributes" },
    seo: { populate: "*" },
  },
});

export const getCards = (section, englishProduct, productItem) =>
  englishProduct?.attributes?.[section]?.data?.attributes?.cards?.data ||
  productItem?.attributes?.[section]?.data?.attributes?.cards?.data ||
  [];
